import React from 'react';
import Card from '../../ui/Card';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
const ROIByRegionChannelTable: React.FC = () => {
  const regionChannelData = [{
    region: 'West',
    digital: 358,
    btl: 298,
    tv: 265,
    print: 212,
    outdoor: 145,
    totalSpend: 125.4,
    totalRevenue: 341.2,
    avgROI: 272
  }, {
    region: 'North',
    digital: 342,
    btl: 285,
    tv: 248,
    print: 195,
    outdoor: 132,
    totalSpend: 108.2,
    totalRevenue: 285.8,
    avgROI: 264
  }, {
    region: 'South',
    digital: 328,
    btl: 278,
    tv: 238,
    print: 188,
    outdoor: 125,
    totalSpend: 95.8,
    totalRevenue: 248.5,
    avgROI: 259
  }, {
    region: 'East',
    digital: 315,
    btl: 265,
    tv: 225,
    print: 178,
    outdoor: 118,
    totalSpend: 74.5,
    totalRevenue: 189.2,
    avgROI: 254
  }];
  const channelTotals = {
    digital: regionChannelData.reduce((sum, r) => sum + r.digital, 0) / 4,
    btl: regionChannelData.reduce((sum, r) => sum + r.btl, 0) / 4,
    tv: regionChannelData.reduce((sum, r) => sum + r.tv, 0) / 4,
    print: regionChannelData.reduce((sum, r) => sum + r.print, 0) / 4,
    outdoor: regionChannelData.reduce((sum, r) => sum + r.outdoor, 0) / 4
  };
  const getROIColor = (roi: number) => {
    if (roi >= 300) return 'text-green-600 font-bold';
    if (roi >= 250) return 'text-green-600';
    if (roi >= 200) return 'text-yellow-600';
    if (roi >= 150) return 'text-orange-600';
    return 'text-red-600';
  };
  const getBestChannel = (row: (typeof regionChannelData)[0]) => {
    const channels = [{
      name: 'Digital',
      value: row.digital
    }, {
      name: 'BTL',
      value: row.btl
    }, {
      name: 'TV',
      value: row.tv
    }, {
      name: 'Print',
      value: row.print
    }, {
      name: 'Outdoor',
      value: row.outdoor
    }];
    return channels.reduce((max, channel) => channel.value > max.value ? channel : max);
  };
  return <Card className="p-6" data-id="element-8004">
      <div className="flex items-center justify-between mb-4" data-id="element-8005">
        <div data-id="element-8006">
          <h3 className="text-lg font-semibold text-gray-800" data-id="element-8007">
            ROI by Region & Channel
          </h3>
          <p className="text-sm text-gray-600" data-id="element-8008">
            Channel performance breakdown across regions (ROI %)
          </p>
        </div>
      </div>
      <div className="overflow-x-auto" data-id="element-8009">
        <table className="w-full" data-id="element-8010">
          <thead data-id="element-8011">
            <tr className="border-b-2 border-gray-300" data-id="element-8012">
              <th className="text-left py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8013">
                Region
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8014">
                Digital
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8015">
                BTL
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8016">
                TV
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8017">
                Print
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8018">
                Outdoor
              </th>
              <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8019">
                Total Spend
              </th>
              <th className="text-right py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8020">
                Total Revenue
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8021">
                Avg ROI
              </th>
              <th className="text-center py-3 px-4 text-sm font-bold text-gray-700" data-id="element-8022">
                Best Channel
              </th>
            </tr>
          </thead>
          <tbody data-id="element-8023">
            {regionChannelData.map((row, index) => {
            const bestChannel = getBestChannel(row);
            return <tr key={index} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-8024">
                  <td className="py-3 px-4 text-sm font-semibold text-gray-800" data-id="element-8025">
                    {row.region}
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-8026">
                    <span className={`text-sm ${getROIColor(row.digital)}`} data-id="element-8027">
                      {row.digital}%
                    </span>
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-8028">
                    <span className={`text-sm ${getROIColor(row.btl)}`} data-id="element-8029">
                      {row.btl}%
                    </span>
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-8030">
                    <span className={`text-sm ${getROIColor(row.tv)}`} data-id="element-8031">
                      {row.tv}%
                    </span>
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-8032">
                    <span className={`text-sm ${getROIColor(row.print)}`} data-id="element-8033">
                      {row.print}%
                    </span>
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-8034">
                    <span className={`text-sm ${getROIColor(row.outdoor)}`} data-id="element-8035">
                      {row.outdoor}%
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-right text-gray-700" data-id="element-8036">
                    ₹{row.totalSpend}L
                  </td>
                  <td className="py-3 px-4 text-sm text-right font-semibold text-gray-900" data-id="element-8037">
                    ₹{row.totalRevenue}L
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-8038">
                    <span className={`text-base font-bold ${getROIColor(row.avgROI)}`} data-id="element-8039">
                      {row.avgROI}%
                    </span>
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-8040">
                    <div className="flex items-center justify-center" data-id="element-8041">
                      <span className="text-sm font-semibold text-gray-800" data-id="element-8042">
                        {bestChannel.name}
                      </span>
                      <TrendingUpIcon size={14} className="ml-1 text-green-600" data-id="element-8043" />
                    </div>
                    <div className="text-xs text-gray-500 mt-0.5" data-id="element-8044">
                      {bestChannel.value}%
                    </div>
                  </td>
                </tr>;
          })}
          </tbody>
          <tfoot data-id="element-8045">
            <tr className="border-t-2 border-gray-300 bg-gray-50" data-id="element-8046">
              <td className="py-3 px-4 text-sm font-bold text-gray-900" data-id="element-8047">
                National Avg
              </td>
              <td className="py-3 px-4 text-center" data-id="element-8048">
                <span className={`text-sm font-bold ${getROIColor(channelTotals.digital)}`} data-id="element-8049">
                  {channelTotals.digital.toFixed(0)}%
                </span>
              </td>
              <td className="py-3 px-4 text-center" data-id="element-8050">
                <span className={`text-sm font-bold ${getROIColor(channelTotals.btl)}`} data-id="element-8051">
                  {channelTotals.btl.toFixed(0)}%
                </span>
              </td>
              <td className="py-3 px-4 text-center" data-id="element-8052">
                <span className={`text-sm font-bold ${getROIColor(channelTotals.tv)}`} data-id="element-8053">
                  {channelTotals.tv.toFixed(0)}%
                </span>
              </td>
              <td className="py-3 px-4 text-center" data-id="element-8054">
                <span className={`text-sm font-bold ${getROIColor(channelTotals.print)}`} data-id="element-8055">
                  {channelTotals.print.toFixed(0)}%
                </span>
              </td>
              <td className="py-3 px-4 text-center" data-id="element-8056">
                <span className={`text-sm font-bold ${getROIColor(channelTotals.outdoor)}`} data-id="element-8057">
                  {channelTotals.outdoor.toFixed(0)}%
                </span>
              </td>
              <td className="py-3 px-4 text-sm text-right font-bold text-gray-900" data-id="element-8058">
                ₹
                {regionChannelData.reduce((sum, r) => sum + r.totalSpend, 0).toFixed(1)}
                L
              </td>
              <td className="py-3 px-4 text-sm text-right font-bold text-gray-900" data-id="element-8059">
                ₹
                {regionChannelData.reduce((sum, r) => sum + r.totalRevenue, 0).toFixed(1)}
                L
              </td>
              <td className="py-3 px-4 text-center" data-id="element-8060">
                <span className={`text-base font-bold ${getROIColor(regionChannelData.reduce((sum, r) => sum + r.avgROI, 0) / 4)}`} data-id="element-8061">
                  {(regionChannelData.reduce((sum, r) => sum + r.avgROI, 0) / 4).toFixed(0)}
                  %
                </span>
              </td>
              <td className="py-3 px-4 text-center text-sm font-bold text-gray-900" data-id="element-8062">
                —
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-8063">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-8064">
          <div className="text-center" data-id="element-8065">
            <div className="text-xs text-gray-600 mb-1" data-id="element-8066">Best Region</div>
            <div className="text-2xl font-bold text-green-600" data-id="element-8067">West</div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-8068">272% Avg ROI</div>
          </div>
          <div className="text-center" data-id="element-8069">
            <div className="text-xs text-gray-600 mb-1" data-id="element-8070">Best Channel</div>
            <div className="text-2xl font-bold text-blue-600" data-id="element-8071">Digital</div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-8072">336% Avg ROI</div>
          </div>
          <div className="text-center" data-id="element-8073">
            <div className="text-xs text-gray-600 mb-1" data-id="element-8074">Total Investment</div>
            <div className="text-2xl font-bold text-gray-900" data-id="element-8075">₹403.9L</div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-8076">
              Across all channels
            </div>
          </div>
          <div className="text-center" data-id="element-8077">
            <div className="text-xs text-gray-600 mb-1" data-id="element-8078">Total Revenue</div>
            <div className="text-2xl font-bold text-purple-600" data-id="element-8079">₹1,064.7L</div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-8080">Attributed revenue</div>
          </div>
        </div>
      </div>
      <div className="mt-4 p-4 bg-purple-50 rounded-lg border border-purple-200" data-id="element-8081">
        <div className="flex items-start" data-id="element-8082">
          <div className="flex-shrink-0 w-2 h-2 rounded-full bg-purple-600 mt-1.5 mr-2" data-id="element-8083" />
          <div className="text-sm text-purple-800" data-id="element-8084">
            <span className="font-semibold" data-id="element-8085">Regional Insight:</span> West region
            leading with 272% average ROI, driven by strong Digital (358%) and
            BTL (298%) performance. East region showing lowest ROI at 254% -
            opportunity to optimize channel mix and improve efficiency.
          </div>
        </div>
      </div>
      <div className="mt-4 grid grid-cols-3 gap-2 text-xs" data-id="element-8086">
        <div className="flex items-center" data-id="element-8087">
          <div className="w-3 h-3 rounded bg-green-500 mr-2" data-id="element-8088" />
          <span className="text-gray-600" data-id="element-8089">Excellent (300%+)</span>
        </div>
        <div className="flex items-center" data-id="element-8090">
          <div className="w-3 h-3 rounded bg-yellow-500 mr-2" data-id="element-8091" />
          <span className="text-gray-600" data-id="element-8092">Good (200-300%)</span>
        </div>
        <div className="flex items-center" data-id="element-8093">
          <div className="w-3 h-3 rounded bg-red-500 mr-2" data-id="element-8094" />
          <span className="text-gray-600" data-id="element-8095">Needs Improvement (&lt;200%)</span>
        </div>
      </div>
    </Card>;
};
export default ROIByRegionChannelTable;